import { Component } from '@angular/core';
import { MainSearchService } from './main-search.service';

@Component({
  selector: 'app-main-search',
  templateUrl: './main-search.component.html',
  styleUrls: ['./main-search.component.scss'],
})
export class MainSearchComponent {
  public input: string;
  public results;
  public isLoading;

  constructor(private searchItems: MainSearchService) {}

  public change(a) {
    if (this.input) {
      this.getData();
    }
    this.results = undefined;
  }

  private async getData() {
    this.isLoading = true;
    try {
      this.results = await this.searchItems.searchItems(this.input);
    } catch (error) {
    } finally {
      this.isLoading = false;
    }
  }
}
